import React, { useRef } from 'react';

import { Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';

import { i18n } from '../../../../symphony';
import s from './AddCourse.scss';

export function AddCourse(): JSX.Element {
  useStyles(s);
  // todo: change ref solution
  const ref = useRef(null);

  const scrollToMainSection = () => {
    ref.current?.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  };

  return (
    <div
      className="le-courses-catalog__no-courses"
      sl-test-data="cmpAddCourse"
    >
      <p className="le-courses-catalog__no-courses__desc">
        {i18n.t('web-le.course-catalog-no-courses-title')}
      </p>
      <Button
        key={1}
        buttonType="primary"
        size="s"
        onClick={scrollToMainSection}
      >
        {i18n.t('web-le.course-catalog-no-courses-button')}
      </Button>
      <div ref={ref} className="le-courses-catalog__no-courses__img">
      </div>
    </div>
  );
}
